/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinancialPlanUpdateDeferredIncomeRequestDto
 */
export interface FinancialPlanUpdateDeferredIncomeRequestDto {
  /**
   *
   * @type {number}
   * @memberof FinancialPlanUpdateDeferredIncomeRequestDto
   */
  amount: number;
}

export function FinancialPlanUpdateDeferredIncomeRequestDtoFromJSON(
  json: any
): FinancialPlanUpdateDeferredIncomeRequestDto {
  return FinancialPlanUpdateDeferredIncomeRequestDtoFromJSONTyped(json, false);
}

export function FinancialPlanUpdateDeferredIncomeRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanUpdateDeferredIncomeRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amount: json["amount"],
  };
}

export function FinancialPlanUpdateDeferredIncomeRequestDtoToJSON(
  value?: FinancialPlanUpdateDeferredIncomeRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
  };
}
